import a from "react";
import { extendTheme as h, ChakraProvider as f } from "@chakra-ui/react";
import { useTheme as p } from "../../hooks/usetheme/usetheme.js";
import { Theme as l } from "../../themes/themes.js";
import { QueryClient as u, QueryClientProvider as k } from "@tanstack/react-query";
import { BASE_FONT as d } from "../../types/constants.js";
import { useTransformTokens as C } from "../../hooks/use-transform-tokens/use-transform-tokens.js";
const E = "https://assets-platform.loblaws.ca/ldp-design-token/tokens", _ = new u(), w = { ...l.localTokens }, N = ({
  children: e,
  themeName: t,
  themeVersion: o = "latest",
  baseFont: r = d,
  env: n = "lower",
  themeBaseUrl: m = E,
  designTokenPlatform: s = "web"
}) => {
  const c = p(
    m,
    t,
    o,
    n,
    s
  ), i = C(w, r);
  if (!i || !c)
    return null;
  l.localTokens = { ...i };
  const T = h(c, l);
  return /* @__PURE__ */ a.createElement(f, { theme: T }, e);
}, Q = ({
  children: e,
  themeName: t,
  themeVersion: o,
  env: r,
  themeBaseUrl: n,
  designTokenPlatform: m,
  baseFont: s
}) => /* @__PURE__ */ a.createElement(k, { client: _ }, /* @__PURE__ */ a.createElement(
  N,
  {
    themeName: t,
    themeVersion: o,
    env: r,
    themeBaseUrl: n,
    designTokenPlatform: m,
    baseFont: s
  },
  e
));
export {
  Q as ThemeProvider
};
